"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _loggerProxy = _interopRequireDefault(require("../logs/logger-proxy"));
var _loggerConfig = _interopRequireDefault(require("../logs/logger-config"));
var _parameter = _interopRequireDefault(require("../errors/parameter"));
var _util = _interopRequireDefault(require("./util"));
var TriggerProxy = {};
TriggerProxy.trigger = function (instance, scope, trigger, payload) {
  if (!instance || !instance.trigger) {
    throw new _parameter.default('Instance to trigger from must be defined and have a trigger function.');
  }
  _loggerProxy.default.logger.debug("".concat(_util.default.getScopeLog(scope), "event#").concat(trigger).concat(_loggerConfig.default.verboseEvents ? " -- ".concat(_util.default.getEventLog(payload)) : ''));
  return instance.trigger(trigger, payload);
};
var _default = TriggerProxy;
exports.default = _default;
//# sourceMappingURL=trigger-proxy.js.map
